import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/FirldTrips/2023/Class7/1.jpg';
// import p2 from 'assests/Photos/FirldTrips/2023/Class7/2.jpg';
// import p3 from 'assests/Photos/FirldTrips/2023/Class7/3.jpg';
// import p4 from 'assests/Photos/FirldTrips/2023/Class7/4.jpg';
// import p5 from 'assests/Photos/FirldTrips/2023/Class7/5.jpg';
// import p6 from 'assests/Photos/FirldTrips/2023/Class7/6.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar_2023 from '../Sidebar_2023';


const CurricularClass72023 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });


  const [config, setConfig] = useState({ base_image_archive_url: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class7/1.webp`;
  const p2 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class7/2.webp`;
  const p3 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class7/3.webp`;
  const p4 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class7/4.webp`;
  const p5 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class7/5.webp`;
  const p6 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class7/6.webp`;


  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
        src: p2,
        source:p2,
        rows: 2,
        cols: 1,
    },
    {
        src: p4,
        source: p4,
        rows: 1,
        cols: 1,
    },
    {
        src: p3,
        source: p3,
        rows: 1,
        cols: 2,
    },
    {
        src: p5,
        source: p5,
        rows: 1,
        cols: 2,
    },
    {
        src: p6,
        source: p6,
        rows: 1,
        cols: 2,
    },
      
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      ‘Field Trip to Elim Resort’
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
 Class: 7   Date: 7 SEPTEMBER 2023 (Thursday)

        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        Our recent school trip to Elim Resort, situated on Kanakpura Road in Bangalore, was an enjoyable and unforgettable experience. We began our journey early in the morning, reached the resort at 9 am and got ready for a day filled with activities and bonding. Upon arrival, we were greeted with the promise of adventure and a hearty breakfast, setting the tone for the day ahead. The aroma of freshly prepared food signalled the start of an exciting day.
        <br />
        The students were divided into two teams and were assigned a different set of activities. One group set out for adventurous sports, while the other was engaged in a variety of games.
        <br />
        The adventurous sports group had their fill of excitement. They took part in activities such as zip-lining, trampoline and navigating high ropes. These challenges encouraged students to conquer their fears. Concurrently, the games group enjoyed friendly competitions, which enhanced teamwork and sportsmanship amongst them. 
        <br />
        As the sun reached its peak, we gathered for a satisfying lunch that refuelled our energy. 
        <br/>
        Following lunch, a delightful surprise awaited us – a Rain dance! The students were divided into two groups again- the boys and the girls. Dancing in the rain surrounded by friends and music, was an unique experience that brought a sense of freedom and joy to their hearts.
        <br/>
        To recharge once more, we indulged in high tea around 3 pm relishing the snacks and ice cream. This break allowed us to unwind and share stories of our day's adventures.
        <br/>
        The day reached its climax with a group photo session at 4 pm against the backdrop of the resort's scenic beauty. We captured the essence of our day in a single frame. The smiles and bonhomie evident in the photograph will forever remind us of this trip.
        <br/>
        As the sun began to set, we boarded the bus back to school, grateful for the memorable day we had experienced. 
        </Typography>
      </Box>
     

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 400 : 300}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
                <Sidebar_2023/>
             </Box>

         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default CurricularClass72023;